import gCard from "@/components/g-card/g-card.vue";
import gForm from "@/components/g-form/g-form.vue";
import gDateInput from "@/components/g-date-input/g-date-input.vue";
import gButton from "@/components/g-button/g-button.vue";
import ClienteController from "@/shared/controllers/cliente/clienteController";
import gDataTable from "@/components/g-data-table/g-data-table.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import { defineComponent } from "vue";
import OrcamentoController from "@/shared/controllers/orcamento/orcamentoController";
import EVENTS from "@/shared/events/events";

const name = "orcamentoemdigitacao";
export default defineComponent({
  name,

  components: {
    "g-card": gCard,
    "g-form": gForm,
    "g-date-input": gDateInput,
    "g-button": gButton,
    "g-data-table": gDataTable,
    'g-pdf': gPdf,
  },

  props: {},

  mounted() {
    // this.getClientes(),
    this.getEmpresa();
      this.mitt.on(EVENTS.trocaEmpresaRepresentante, () => {
      this.RepresentanteId = this.$store.state.representanteSelecionadoId;
      this.formSearch.UnidadeId = this.$store.state.empresaSelecionadaId;
    })

    this.RepresentanteId = this.$store.state.representanteSelecionadoId;
  },

  updated() {},

  data() {
    return {
      confirmacaoExclusao: false,
      indexOrcamentoDeletado: null,
      RepresentanteId: null,
      orcamentoSelecioadoId: '',
      formSearch: {
        UnidadeId: null,
        CLienteId: null,
        DataInicio: null,
        DataFim: null,
      },

      ClienteSelecionado: null,
      colunasOrcamentosDigitacao: null,
      dataClientes: [],
      EmpresaArray: [],
      EmpresaSelecionada: null,
      informacaoOrcamentoSelecionado: null,
      mensagemvazio: true,
      OrcamentoArray: [],
      OrcamentoSelecionado: '',
      pdfdownload: false,
      pdfvisualizacao: false,
      popup: false,
      redirecionarParaOrcamento: false,
      renderiza: false,

      Colunas: [
        //Campo dos dados , nome que aparece na página
        // { field: "id", header: "N° Solicitação", width: '50px', ordena: true },
        { field: "tipoText", header: "Tipo", width: '260px', ordena: true },
        { field: "dataEHoraJuntasFormatado", header: "Data", width: '80px', ordena: true, ordenacao: 'dataEHoraJuntas' },
        { field: "nomeEmpresa", header: "Empresa", width: '250px', ordena: true },
        { field: "nomeRepresentante", header: "Representante", width: '200px', ordena: true },
        { field: "clienteNome", header: "Cliente", width: '280px', ordena: true },
        { field: "curvaCliente", header: "CV", width: '50px', ordena: true },
      ],
      Filtro: {
        global: { value: null, matchMode: this.filtros.CONTAINS }, //permite buscar por colunas específicas
        vin: { value: null, matchMode: this.filtros.CONTAINS },
        tipoText: { value: null, matchMode: this.filtros.CONTAINS },
        dataDigitacaoFormatadaText: {
          value: null,
          matchMode: this.filtros.CONTAINS,
        },
        nomeEmpresa: { value: null, matchMode: this.filtros.CONTAINS },
        nomeRepresentante: { value: null, matchMode: this.filtros.CONTAINS },
        status: { value: null, matchMode: this.filtros.CONTAINS },
        CV: { value: null, matchMode: this.filtros.CONTAINS },
      },
      timer: null,
    };
  },

  methods: {
    buscar() {
        this.$isLoading(true)
        this.formSearch.RepresentanteId = this.RepresentanteId;
        this.axios({
          method: "post",
          data: this.formSearch,
          url:
            process.env.VUE_APP_WEB_API + "Orcamento/GetOrcamentoEmDigitacao",
        })
          .then((response) => {
            this.mensagemvazio = false;
            this.OrcamentoArray = response.data.data ? response.data.data : [];
          })
          .finally(()=> {
            this.$isLoading(false)
          })
    },

    excluirOrcamentoDigitacao(data, index){
      this.confirmacaoExclusao = true;
      this.orcamentoSelecioadoId = data.id;
      this.indexOrcamentoDeletado = index;
    },

    confirmarExclusaoOrcamento(){
      this.$isLoading(true)
      OrcamentoController.DeletarOrcamentoDigitacao(this.orcamentoSelecioadoId).requisicao
        .then(res => {
          if(res.data.data){
            this.$toast.add({ severity: 'success', summary: 'Orçamento deletado!', life: 3200 });
            this.confirmacaoExclusao = false;
            this.OrcamentoArray.splice(this.indexOrcamentoDeletado, 1);
            return
          }
          this.$toast.add({ severity: 'error', summary: 'Erro ao deletar orçamento', life: 3200 });
        }).finally(()=> {
          this.$isLoading(false)
        })
    },

    continuarOrca(informacaoDaLinha) {
      let OrcamentoId = informacaoDaLinha.id;
      let tipoFluxoOrcamento = informacaoDaLinha.tipoFluxoOrcamento;

      switch (tipoFluxoOrcamento) {
        case 0:
          this.$router.push(`/produto-novo/${OrcamentoId}/infos-cliente`);
          break;
        case 1:
          this.$router.push(
            `/produto-repeticao/${OrcamentoId}/Informacao-Cliente-Repeticao`
          );
          break;
        case 2:
          this.$router.push(
            `/produto-repeticao-alteracao/${OrcamentoId}/info-cliente-ra`
          );
          break;
      }
    },

    imprimir(data){
      if(this.orcamentoSelecionado === data.id){
        this.orcamentoSelecionado = '';
      }
      setTimeout(()=>{
        this.renderiza = true
        this.pdfvisualizacao = true
        this.pdfdownload = false
        this.orcamentoSelecionado = data.id
      })
    },

    redireciona() {
      this.continuarOrca(this.informacaoOrcamentoSelecionado);
    },

    abrePopup(informacaoDaLinha) {
      this.popup = true;
      this.informacaoOrcamentoSelecionado = informacaoDaLinha;
    },

    clear() {
      Object.keys(this.formSearch).forEach((Element) => {
        this.formSearch[Element] = null;
      });
    },

    fechaPopup() {
      this.popup = false;
    },

    buscarClientes(event){

      window.clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.dataClientes = ClienteController.getClienteDropDownsByNome(event, this.formSearch.UnidadeId, this.RepresentanteId).ClientesArray;
      }, 1000);
    },

    getEmpresa() {
      this.EmpresaArray = this.$store.state.EmpresaArray;
    },
  },

  computed: {},
});
